import { Heart } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

interface Parent {
  id: string;
  email: string;
  relationshipType: string | null;
}

interface ParentsSectionProps {
  parents: Parent[];
}

export function ParentsSection({ parents }: ParentsSectionProps) {
  return (
    <div className="bg-card rounded-lg shadow p-6">
      <div className="flex items-center gap-2 mb-4">
        <Heart className="w-5 h-5 text-muted-foreground" />
        <h2 className="font-semibold">Parents / Guardians</h2>
        <span className="text-sm text-muted-foreground">({parents.length})</span>
      </div>
      {parents.length === 0 ? (
        <p className="text-muted-foreground text-sm">No parents linked</p>
      ) : (
        <ul className="space-y-2">
          {parents.map((parent) => (
            <li key={parent.id} className="flex items-center gap-2 text-sm">
              <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                <span className="text-green-600 font-medium text-xs">
                  {parent.email[0].toUpperCase()}
                </span>
              </div>
              <span>{parent.email}</span>
              {parent.relationshipType && (
                <Badge variant="outline" className="text-xs capitalize">
                  {parent.relationshipType}
                </Badge>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
